/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppUpdateCompositionsDetailMutationRequest, WebAppUpdateCompositionsDetailMutationResponse, WebAppUpdateCompositionsDetailPathParams, WebAppUpdateCompositionsDetail401, WebAppUpdateCompositionsDetail403 } from "../models/WebAppUpdateCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppUpdateCompositionsDetail } from "../axios/webAppUpdateCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppUpdateCompositionsDetailMutationKey = () => [{ url: '/web-app/v1/compositions/:id' }] as const

export type WebAppUpdateCompositionsDetailMutationKey = ReturnType<typeof webAppUpdateCompositionsDetailMutationKey>

export function webAppUpdateCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppUpdateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppUpdateCompositionsDetailMutationKey()
        return mutationOptions<WebAppUpdateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppUpdateCompositionsDetail401 | WebAppUpdateCompositionsDetail403>, {id: WebAppUpdateCompositionsDetailPathParams["id"], data: WebAppUpdateCompositionsDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return webAppUpdateCompositionsDetail(id, data, config)
          },
        })

}

/**
 * @summary Update a composition by id
 * {@link /web-app/v1/compositions/:id}
 */
export function useWebAppUpdateCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppUpdateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppUpdateCompositionsDetail401 | WebAppUpdateCompositionsDetail403>, {id: WebAppUpdateCompositionsDetailPathParams["id"], data: WebAppUpdateCompositionsDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppUpdateCompositionsDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppUpdateCompositionsDetailMutationKey()

          const baseOptions = webAppUpdateCompositionsDetailMutationOptions(config) as UseMutationOptions<WebAppUpdateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppUpdateCompositionsDetail401 | WebAppUpdateCompositionsDetail403>, {id: WebAppUpdateCompositionsDetailPathParams["id"], data: WebAppUpdateCompositionsDetailMutationRequest}, TContext>
          

          return useMutation<WebAppUpdateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppUpdateCompositionsDetail401 | WebAppUpdateCompositionsDetail403>, {id: WebAppUpdateCompositionsDetailPathParams["id"], data: WebAppUpdateCompositionsDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppUpdateCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppUpdateCompositionsDetail401 | WebAppUpdateCompositionsDetail403>, {id: WebAppUpdateCompositionsDetailPathParams["id"], data: WebAppUpdateCompositionsDetailMutationRequest}, TContext>
      
}